export default __webpack_public_path__ + "static/media/landing_mobile.c067c3ea.png";